import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 277.15 158.48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M277.15 38.93c-81.4-13.71-122.11 83.17-188.03 91.58C41.34 136.71 6.39 102.2.2 76.98c-3.54 48.67 40.7 83.62 89.81 81.4 82.73-3.54 126.53-103.97 187.14-119.45m-63.26-1.32c-61.94-8.41-76.98 37.61-126.97 53.97-32.3 10.62-57.07 2.65-75.21-17.25 8.41 26.54 40.26 45.13 68.13 42.91 55.3-4.42 86.71-65.48 134.05-79.63",
      style: {"fill":"#0054a5"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M82.05 79.63c11.95-3.98 20.35-8.85 27.43-13.71 5.75-3.98 26.1-18.14 36.28-24.78C137.35 17.25 113.9 0 86.91 0 52.4 0 24.09 27.87 24.09 62.82c0 3.1 0 5.75.44 8.41 15.04 10.62 34.95 15.93 57.51 8.41",
      style: {"fill":"#ffca05"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "BJ-logo"}) } }